import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import gitlabPlugin from '@immobiliarelabs/backstage-plugin-gitlab/alpha';
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import { goalertModule } from './modules/goalert';
import { grafanaAlertsModule } from './modules/grafanaAlerts';
import { observabilityTabModule } from './modules/observabilityTab';
import { techInsightsScorecardModule } from './modules/techInsightsScorecard';
import { kubernetesWithOidc } from './modules/kubernetesAuth';

export default createApp({
  features: [
    catalogPlugin,
    // kubernetesWithOidc IS the kubernetes plugin, with its auth-providers API
    // extension overridden to add the `aknostic` OIDC slot. It replaces the
    // bare kubernetesPlugin feature — registering both would re-run the plugin.
    kubernetesWithOidc,
    gitlabPlugin,
    // Grafana plugin (/alpha): registers three EntityCardBlueprint cards
    // (dashboards, alerts, overview-dashboard) that self-attach to the entity
    // page. Each card's built-in filter gates it on the grafana/* annotations
    // (dashboard-selector, alert-label-selector, overview-dashboard), so cards
    // appear only on the 6 entities carrying them. No module needed — unlike
    // goalert, these cards ship with the plugin; adding the feature is enough.
    // Backend proxy + grafana.domain config live in app-config.production.yaml.
    //
    // EXCEPTION: the stock `entity-card:grafana/alerts` card is disabled in
    // app-config.yaml and replaced by grafanaAlertsModule, which renders
    // EntityGrafanaAlertsCard with `showState` to add a colored State column.
    // The /alpha alerts extension hardcodes the opts off, so it can't be
    // enabled via config — hence a custom module. dashboards and
    // overview-dashboard cards are left to the plugin untouched.
    grafanaPlugin,
    navModule,
    authModule,
    goalertModule,
    grafanaAlertsModule,
    // Observability entity tab: hosts the Grafana Dashboards + state-aware
    // Alerts cards, which are disabled on the Overview tab in app-config.yaml.
    // Attaches only to entities carrying a grafana selector annotation.
    observabilityTabModule,
    // Tech Insights: the frontend plugin provides the scorecard surface and
    // auto-discovers; techInsightsScorecardModule's blueprint scopes the
    // "SLO Compliance" scorecard to sloComplianceCheck on kind:component.
    techInsightsPlugin,
    techInsightsScorecardModule,
  ],
});
